export default ({
  launchDateYear,
  launchDateMonth,
  launchDateDay,
  launchDateHour,
  launchDateMinute,
  launchStatusOverride,
}) => ({
  launchDateYear,
  launchDateMonth,
  launchDateDay,
  launchDateHour,
  launchDateMinute,

  hasLaunched: launchStatusOverride === 'true',
  hasCalculated: false,
  intervalTimer: null,

  hours: '--',
  minutes: '--',
  seconds: '--',

  init() {
    if (this.hasLaunched) {
      return;
    } else {
      this.interval = setInterval(() => this.op(), 1000);
    }
  },
  destroy() {
    this.wipeInterval();
  },
  get hourFormat() {
    return this.hours.length > 2 ? 'hhh' : 'hh';
  },
  get launchDate() {
    return new Date(
      Date.UTC(
        this.launchDateYear,
        this.launchDateMonth,
        this.launchDateDay,
        this.launchDateHour,
        this.launchDateMinute
      )
    );
  },
  op() {
    const { hours, minutes, seconds, hasLaunchedDetermination } =
      this.calculateCountdown();

    if (!hasLaunchedDetermination) {
      // Most of the time, hasLaunchedDetermination will be false, so we'll update the countdown timer
      // this.days = days;
      this.hours = hours;
      this.minutes = minutes;
      this.seconds = seconds;
    } else {
      // else cleanup for static rendering of the hasLaunched message
      this.wipeInterval();
      this.hasLaunched = true;
    }

    this.hasCalculated = true;
  },
  calculateCountdown() {
    const now = new Date();
    const target = this.launchDate;
    // EARLY RETURN: if now is past target time, return hasLaunchedDetermination as true
    if (now.getTime() > target.getTime()) {
      return {
        hasLaunchedDetermination: true,
      };
    }

    let secondsRemaining = (target.getTime() - now.getTime()) / 1000;
    const hours = pad(parseInt(secondsRemaining / 3600));
    secondsRemaining = secondsRemaining % 3600;
    const minutes = pad(parseInt(secondsRemaining / 60));
    const seconds = pad(parseInt(secondsRemaining % 60));
    return {
      hours,
      minutes,
      seconds,
      hasLaunchedDetermination: false,
    };
  },
  wipeInterval() {
    clearInterval(this.interval);
  },
});

function pad(n) {
  return (n < 10 ? '0' : '') + n;
}
